import {
    UPDATE_ORDER,
    ADD_ORDER,
    REMOVE_ORDER,
    GET_ALL_ORDERS,
    UPDATE_ORDERS,
    ASSIGN_ORDER,
    FORCE_UPDATE_ORDER,
    CANCEL_ORDER,
} from './order.actionsTypes';

import {
    ORDER_STATUSES
} from '../../config/constants';

import diff from 'deep-diff';

const updateSupplier = (suppliers, order) => {
    suppliers.forEach((supplier) => {
        const shops = order.shops || [];
        shops.forEach((shop) => {
            if (shop._id === supplier.id && supplier.hasOwnProperty('status')) {
                shop.status = supplier.status;
            }
            if (shop._id === supplier.id && supplier.hasOwnProperty('state')) {
                shop.state = supplier.state;
            }
        });
    });
};

const updateOrder = (state, order) => {
    const newState = state.map((item) => {
        const id = order._id || order.orderId || order.id;
        if (item.orderId === id || id === item._id) {
            const suppliers = order.suppliers;
            let distributorRejectionReasons = order.distributorRejectionReasons;
            delete order.suppliers;
            if (order.hasOwnProperty('status') && item.status !== order.status) {
                item.rejectedBlink = (item.status === ORDER_STATUSES.REJECTED.statusId);
            }
            if (distributorRejectionReasons && !Array.isArray(distributorRejectionReasons)) {
                const list = item.distributorRejectionReasons || [];
                list.push(distributorRejectionReasons);
                order.distributorRejectionReasons = list;
            }
            Object.assign(item, order);
            if (suppliers) {
                updateSupplier(suppliers, item);
            }
        }
        return item;
    });
    return newState;
};

const sortOrders = (orders) => {
    orders.sort((a, b) => {
        if (a.status === ORDER_STATUSES.DRAFT.statusId && b.status !== ORDER_STATUSES.DRAFT.statusId) {
            return -1;
        } else if (a.status !== ORDER_STATUSES.DRAFT.statusId && b.status === ORDER_STATUSES.DRAFT.statusId) {
            return 1;
        }
        if (a.eta < b.eta) {
            return -1;
        } else if (a.eta > b.eta) {
            return 1;
        }
        return a.orderId - b.orderId;
    });
};

const removeFinishedOrders = (orders) => {
    return orders.filter((order) => {
        return order.status !== ORDER_STATUSES.DELIVERED.statusId && order.status !== ORDER_STATUSES.CANCELED.statusId;
    });
};

const finalizeOrders = (orders) => {
    sortOrders(orders);
    return removeFinishedOrders(orders);
};

export default function orders(state = [], action) {
    // keep legacy state shape (array) for compatibility; we perform
    // careful updates to avoid scanning the array multiple times.
    let newState = Object.assign([], state);
    switch (action.type) {
        case UPDATE_ORDERS: {
            if (!action.orders || !action.orders.length) {
                return state; // nothing to do
            }
            // build quick lookup map for the incoming batch (O(m))
            const updatesById = {};
            action.orders.forEach((order) => {
                const id = order._id || order.orderId || order.id;
                if (id) {
                    updatesById[id] = order;
                }
            });

            // single pass over existing array (O(n))
            newState = newState.map((item) => {
                const id = item.orderId || item._id || item.id;
                const order = updatesById[id];
                if (order) {
                    // reuse the same merge logic as before
                    const suppliers = order.suppliers;
                    let distributorRejectionReasons = order.distributorRejectionReasons;
                    delete order.suppliers;
                    if (
                        order.hasOwnProperty('status') &&
                        item.status !== order.status
                    ) {
                        item.rejectedBlink =
                            item.status === ORDER_STATUSES.REJECTED.statusId;
                    }
                    if (
                        distributorRejectionReasons &&
                        !Array.isArray(distributorRejectionReasons)
                    ) {
                        const list = item.distributorRejectionReasons || [];
                        list.push(distributorRejectionReasons);
                        order.distributorRejectionReasons = list;
                    }
                    Object.assign(item, order);
                    if (suppliers) {
                        updateSupplier(suppliers, item);
                    }
                }
                return item;
            });

            return finalizeOrders(newState);
        }
        case UPDATE_ORDER:
            return finalizeOrders(updateOrder(newState, action.order));
        case ASSIGN_ORDER:
            return newState.map((item, index) => {
                let newItem = Object.assign({}, item);
                if (newItem._id === action.order._id) {
                    newItem.status = action.order.status;
                    newItem.distributor = action.order.distributor;
                }
                return newItem;
            });
        case ADD_ORDER:
            let canAdd = true;
            newState.forEach((order) => {
                if (order._id === action.order._id) {
                    canAdd = false;
                }
            });
            if (canAdd) {
                newState = [action.order, ...newState];
            }
            return finalizeOrders(newState);
        case REMOVE_ORDER:
            return newState.filter((item, index) => {
                return item.id !== action.id;
            });
        case GET_ALL_ORDERS:
            let orders = Object.assign([], action.orders);
            return finalizeOrders(orders);
        case FORCE_UPDATE_ORDER:
            const newOrder = action.order;
            const newOrders = newState.map((order) => {
                if (order._id === action.order._id) {
                    if (order.userUpdate) {
                        action.order.blink = false;
                    } else {
                        const differences = diff(order, newOrder, (path, key) => {
                            return key === 'blink' || key === 'rejectedBlink' ||
                                key === 'userUpdate' || key === 'updatedByWeb';
                        });
                        newOrder.differences = differences;
                    }
                    // For order detail view
                    order.shops = newOrder.shops;
                    order = newOrder;
                }
                return order;
            });
            return finalizeOrders(newOrders);
        case CANCEL_ORDER:
            // TODO: Implement functionality
            return newState;
        default:
            return newState;
    }
}
